export default {
  resource:{
    zh: {
      companyNo: "公司",
      companyName: "公司",
      rq: "日期",
      rq1: "开始日期",
      rq2: "结束日期",
      bh: "编号",
      rq:"体检日",
      xm: "姓名",
      checkProject:	"体检项目",
      checkResult:	"体检结果",
      dept:	"医院",
      doctor:	"医生",
      checkPay:"体检费用",
      remark:	"备注",
      userNo:"用户编号",
      updatedDate:"更新日期",
      health: "健康状态",

      updatedDate:"部门名称不能为空！",
      alExists:"部门序号或名称已经存在，请检查！",
      nameExist:"部门已经存在，请检查！"
    }
  },
  delConf:["xm"],
  delKeys:["autoid"],
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options:"company"
    },
    rq1:{
      key: "rq",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2:{
      key: "rq",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    bh:{
      key: "bh",
      data: null,
      method: "Equal",
      type: "number"
    },
    xm:{
      key: "xm",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [    
    "companyName",{key:"rq", formatter:"fdate"},"bh","xm","checkProject","checkResult", "health","dept","doctor","checkPay","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"rq",
  defaultSortOrder:"desc",
  sortName: "rq",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "empHealth/",
  autoId: "autoid"

}
